export default {
    todoExpres: {
        vtr_com: true,
        sucursal_virtual: false
    },
    cortina: {
        activa: false
    },
    paymentMethods: {
        vtr_com: {
            webpay: true,
            servipag: true,
            compraqui: true
        },
        sucursal_virtual: {
            webpay: true,
            servipag: true,
            compraqui: true
        },
        baf: {
            webpay: true,
            servipag: true,
            compraqui: true
        },
        vtr_com_puf: {
            webpay: true,
            servipag: false,
            compraqui: true
        },

        sucursal_virtual_puf: {
            webpay: true,
            servipag: false,
            compraqui: true
        },
        baf_puf: {
            webpay: true,
            servipag: false,
            compraqui: true
        },

    },
    url: {
        error: process.env.VUE_APP_ENDPOINT_NOT_FOUND_URL,
        base: process.env.VUE_APP_ENDPOINT_PUBLIC_PATH_URI,
        svHome: process.env.VUE_APP_ENDPOINT_BACK_HOME_SV,
        comHome: process.env.VUE_APP_ENDPOINT_BACK_HOME_COM,
        appHome: process.env.VUE_APP_ENDPOINT_BACK_HOME_SV, // TBD
    },
    env: process.env.NODE_ENV,
    errorBilling: process.env.VUE_APP_ENDPOINT_ERROR_BILLING,
    notDue: process.env.VUE_APP_ENDPOINT_NOT_DUE,
    dominios: {
        vtr: process.env.VUE_APP_ENDPOINT_DOMINIO_VTR,
        vtr_cloud: process.env.VUE_APP_ENDPOINT_DOMINIO_VTR_CLOUD,
        sv: process.env.VUE_APP_ENDPOINT_DOMINIO_SUCURSAL,
        sv_cloud: process.env.VUE_APP_ENDPOINT_DOMINIO_SUCURSAL_CLOUD,
        kepler: process.env.VUE_APP_ENDPOINT_DOMINIO_KEPLER,
        kepler_cloud: process.env.VUE_APP_ENDPOINT_DOMINIO_KEPLER_CLOUD,
        mysof: process.env.VUE_APP_ENDPOINT_DOMINIO_MYSOF_CLOUD,
        imgs: process.env.VUE_APP_ENDPOINT_DOMINIO_IMGS
    },
    redes: {

        facebook: process.env.VUE_APP_ENDPOINT_FACEBOOK,
        twitter: process.env.VUE_APP_ENDPOINT_TWITTER,
        youtube: process.env.VUE_APP_ENDPOINT_YOUTUBE
    },
    endpoints: {
        invoicePdf: process.env.VUE_APP_ENDPOINT_INVOICE_PDF,
        sendInvoiceEmail: process.env.VUE_APP_ENDPOINT_SEND_INVOICE_EMAIL,
        billingAccounts: process.env.VUE_APP_ENDPOINT_BILLING_ACCOUNTS,
        paymentMethods: process.env.VUE_APP_ENDPOINT_PAYMENT_METHODS,
        paymentMethodsAWS: process.env.VUE_APP_ENDPOINT_PAYMENT_METHODS_AWS,
        validateOffers: process.env.VUE_APP_ENDPOINT_VALIDAR_OFERTAS,
        getFeatures: process.env.VUE_APP_ENDPOINT_FEATURES,
        initTransaction: process.env.VUE_APP_ENDPOINT_INIT_TRANSACTION,
        invoice: process.env.VUE_APP_ENDPOINT_PAYMENT_INVOCE,
        errorVoucher: process.env.VUE_APP_ENDPOINT_PAYMENT_ERROR,
        home: process.env.VUE_APP_ENDPOINT_BACK_HOME,
        contact: process.env.VUE_APP_ENDPOINT_RESUME_CONTACT,
        session: process.env.VUE_APP_ENDPOINT_SESSION,
        oauthToken: process.env.VUE_APP_ENDPOINT_OAUTHTOKEN,
        paymentStatus: process.env.VUE_APP_ENDPOINT_PAYMENT_STATUS,
        curtain: process.env.VUE_APP_ENDPOINT_CURTAIN,
        getDataUser: process.env.VUE_APP_ENDPOINT_DATA_USER,
        getClientCuentaMovil: process.env.VUE_APP_ENDPOINT_CLIENTE_CUENTA_MOVIL,
        registrarIntereaccion: process.env.VUE_APP_ENDPOINT_REGISTRAR_INTERACCION
    },
    storage: {
        key: "payment"
    },
    redesSociales: {
        facebook: process.env.FACEBOOK,
        twitter: process.env.TWITTER,
        youtube: process.env.YOUTUBE,
    },
    menuItems: {
        vtrcom: [{
                id: 1,
                text: "Packs",
                submenuItems: [{
                        id: 1,
                        type: "img",
                        src: "/static/html/com/img/triple-pack-vive-mas-red.svg",
                        text: "Triple Packs",
                        href: "/productos/HogarPacks/triple-pack-banda-ancha-television-telefonia",
                        items: [{
                                id: 1,
                                type: "img",
                                src: "/static/html/com/contenidos/arrow-rose-ft.png",
                                href: "/productos/HogarPacks/triple-pack-banda-ancha-television-telefonia",
                                text: "70 canales HD + VOD gratis"
                            },
                            {
                                id: 2,
                                type: "img",
                                src: "/static/html/com/contenidos/arrow-rose-ft.png",
                                href: "/productos/HogarPacks/triple-pack-banda-ancha-television-telefonia",
                                text: "Mega 30 / 200 / 400"
                            },
                            {
                                id: 3,
                                type: "img",
                                src: "/static/html/com/contenidos/arrow-rose-ft.png",
                                href: "/productos/HogarPacks/triple-pack-banda-ancha-television-telefonia",
                                text: "Telefonía ilimitada"
                            },
                            {
                                id: 4,
                                type: "text",
                                href: "/productos/HogarPacks/triple-pack-banda-ancha-television-telefonia",
                                text: "+ info"
                            }
                        ]
                    },
                    {
                        id: 2,
                        type: "img",
                        src: "/static/html/com/img/doble-pack-vive-mas-green.svg",
                        text: "Doble Packs",
                        href: "/productos/HogarPacks/doble-pack-banda-ancha-television",
                        items: [{
                                id: 1,
                                type: "img",
                                src: "/static/html/com/contenidos/arrow-rose-ft.png",
                                href: "/productos/HogarPacks/doble-pack-banda-ancha-television",
                                text: "70 canales HD + VOD gratis"
                            },
                            {
                                id: 2,
                                type: "img",
                                src: "/static/html/com/contenidos/arrow-rose-ft.png",
                                href: "/productos/HogarPacks/doble-pack-banda-ancha-television",
                                text: "Mega 30 / 200 / 400"
                            },
                            {
                                id: 3,
                                type: "text",
                                href: "/productos/HogarPacks/doble-pack-banda-ancha-television",
                                text: "+ info"
                            }
                        ]
                    },
                    {
                        id: 3,
                        type: "icon",
                        icon: "icon-ico-packs",
                        text: "OTROS",
                        href: "/productos/HogarPacks/doble-pack-banda-ancha-television",
                        items: [{
                                id: 1,
                                type: "img",
                                src: "/static/html/com/contenidos/arrow-rose-ft.png",
                                href: "/productos/HogarPacks/doble-pack-banda-ancha-television",
                                text: "Televisión + Banda Ancha"
                            },
                            {
                                id: 2,
                                type: "img",
                                src: "/static/html/com/contenidos/arrow-rose-ft.png",
                                href: "/productos/HogarPacks/doble-pack-banda-ancha-telefonia",
                                text: "Banda Ancha + Telefonía"
                            },
                            {
                                id: 3,
                                type: "img",
                                src: "/static/html/com/contenidos/arrow-rose-ft.png",
                                href: "/productos/HogarPacks/doble-pack-television-telefonia",
                                text: "Televisión + Telefonía"
                            },
                            {
                                id: 4,
                                type: "img",
                                src: "/static/html/com/contenidos/arrow-rose-ft.png",
                                href: "https://vtr.com/productos/detalle/prodPIL000/Fono%20Ilimitado%20600%20M%C3%B3vil?content=1&amp;Tipo=C2C&amp;tipo_contratacion=hogar",
                                text: "Telefonía Fija"
                            }
                        ]
                    }
                ]
            },
            {
                id: 2,
                text: "Internet",
                submenuItems: [{
                    id: 1,
                    type: "img",
                    href: "/productos/HogarPacks/banda-ancha",
                    src: "/static/html/com/img/mega400-white.svg",
                    items: [{
                            type: "img",
                            text: "Velocidad máxima de bajada de 400 Mbps"
                        },
                        {
                            type: "img",
                            text: "Con Nextgen WiFi"
                        },
                        {
                            type: "text",
                            text: "+ info"
                        },
                    ]
                }]
            },
            {
                id: 3,
                text: "Televisión"
            },
            {
                id: 4,
                text: "Móvil"
            },
            {
                id: 5,
                text: "Entretención"
            },
            {
                id: 6,
                text: "Centro de ayuda"
            }
        ]
    },
    footer: {
        informacion: {
            url: "/",
            text: "¿Necesitas otro tipo de información?"
        },
        iravtr: {
            url: "/",
            text: "Ir a VTR.com"
        },
        social: {
            facebook: "https://www.facebook.com/VTRChile",
            twitter: "https://twitter.com/vtrchile",
            youtube: "http://www.youtube.com/user/VTRChile"
        },
        links: {
            condiciones: {
                text: "Condiciones de uso vtr.com",
                url: "https://vtr.com/condiciones-uso"
            },
            privacidad: {
                url: "https://vtr.com/politica-privacidad",
                text: "Privacidad"
            },
            vtr: {
                url: "/",
                text: "VTR Comunicaciones SPA"
            }
        }
    },
    header: {
        vtr: "/"
    },
    b2b: {
        rutMax: 50000000
    }
}